import moment from "moment";
import React, { useCallback, useRef, useState } from "react";

import { useReactToPrint } from "react-to-print";
import { Spinner, Table } from "reactstrap";

export const ButtonPrint = ({ innerRef, title }) => {
  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  const reactToPrintContent = useCallback(() => {
    return innerRef.current;
  }, [innerRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);
    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: title,
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  return (
    <button
      type="submit"
      className="btn btn-item"
      onClick={() => {
        handlePrint();
      }}
    >
      CETAK &nbsp;{loadingPrint ? <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner> : ""}
    </button>
  );
};

const PAGE_ROW_LIMIT = 90;

const cellStyle = {
  border: "1px solid black",
  padding: "4px",
  textAlign: "center",
  verticalAlign: "top",
  wordWrap: "break-word",
};

function romanize(num) {
  if (!+num) return false;
  var digits = String(+num).split(""),
    key = ["", "C", "CC", "CCC", "CD", "D", "DC", "DCC", "DCCC", "CM", "", "X", "XX", "XXX", "XL", "L", "LX", "LXX", "LXXX", "XC", "", "I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX"],
    roman = "",
    i = 3;
  while (i--) roman = (key[+digits.pop() + i * 10] ?? "") + roman;
  return Array(+digits.join("") + 1).join("M") + roman;
}

function numberToWords(input) {
  const number = Number(input);

  if (isNaN(number)) {
    return "Input harus angka yang valid (contoh: 6500000 atau '6500000')";
  }

  if (number < 0) {
    return "Input harus non-negatif";
  }

  const num = Math.floor(number);

  if (num === 0) {
    return "Nol Rupiah";
  }

  const satuan = ["", "Satu", "Dua", "Tiga", "Empat", "Lima", "Enam", "Tujuh", "Delapan", "Sembilan"];
  const belasan = ["Sepuluh", "Sebelas", "Dua Belas", "Tiga Belas", "Empat Belas", "Lima Belas", "Enam Belas", "Tujuh Belas", "Delapan Belas", "Sembilan Belas"];
  const puluhan = ["", "", "Dua Puluh", "Tiga Puluh", "Empat Puluh", "Lima Puluh", "Enam Puluh", "Tujuh Puluh", "Delapan Puluh", "Sembilan Puluh"];
  const skala = ["", "Ribu", "Juta", "Miliar", "Triliun", "Kuadriliun", "Kuintiliun"];

  function convertLessThanThousand(n) {
    if (n === 0) return "";
    if (n < 10) return satuan[n];
    if (n < 20) return belasan[n - 10];
    if (n < 100) {
      const p = puluhan[Math.floor(n / 10)];
      const s = satuan[n % 10];
      return p + (s ? " " + s : "");
    }
    const ratus = satuan[Math.floor(n / 100)];
    const sisa = n % 100;
    let hasil = ratus + " Ratus";
    if (sisa > 0) hasil += " " + convertLessThanThousand(sisa);
    return hasil;
  }

  let parts = [];
  let temp = num;
  while (temp > 0) {
    parts.push(temp % 1000);
    temp = Math.floor(temp / 1000);
  }

  let result = [];
  for (let i = parts.length - 1; i >= 0; i--) {
    const val = parts[i];
    if (val === 0) continue;

    let chunk = convertLessThanThousand(val);
    if (i > 0) {
      chunk += " " + skala[i];
    }
    if (chunk) result.push(chunk);
  }

  let final = result.join(" ");

  final = final.replace(/^Satu Ribu\b/, "Seribu");

  final = final.replace(/Satu Ratus(?=.*(Juta|Miliar|Triliun|Kuadriliun|Kuintiliun))/g, "Seratus");

  return final + " Rupiah";
}

export const PrintDoc = ({ innerRef, item }) => {
  const validValue = (val) => {
    return <span className="courier-prime-bold text-capitalize">{`${val || "..................."}`}</span>;
  };

  const handleValidDate = (date) => {
    return moment(date).format("MMM D, YYYY");
  };
  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }
  return !item || item === undefined || item === null ? (
    <></>
  ) : (
    <div
      // className="d-none"
      style={{
        overflow: "scroll",
        //backgroundColor: "blue"
      }}
    >
      <div ref={innerRef}>
        <div style={{ padding: "40px 80px", fontSize: "14px", fontFamily: "serif", color: "#000" }}>
          <div style={{ textAlign: "center", fontWeight: "bold", fontSize: "18px", marginBottom: "5px" }}>SURAT PERJANJIAN KERJA KONTRAK</div>
          <div style={{ textAlign: "center", fontWeight: "bold", fontSize: "18px" }}>PESONA KAHURIPAN 13</div>
          <div
            style={{
              height: "1px",
              width: "100%",
              backgroundColor: "black",
              marginBottom: "20px",
            }}
          ></div>
          <div style={{ textAlign: "center", marginBottom: "20px", fontWeight: "bold" }}>
            Nomor: {validValue(item?.code)}/PKWT/
            {romanize(moment().format("M"))}/{moment().format("YYYY")}
          </div>

          <p>Yang bertanda tangan di bawah ini :</p>

          <table style={{ marginBottom: "10px", marginTop: "10px" }}>
            <tbody>
              <tr>
                <td style={{ verticalAlign: "top", width: "30px" }}>1.</td>
                <td style={{ width: "120px" }}>Nama </td>
                <td style={{ width: "20px" }}>:</td>
                <td style={{ fontWeight: "bold" }}>{validValue("Dimas Wardiansah Ramadan")}</td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top" }}></td>
                <td>Alamat</td>
                <td style={{ width: "20px" }}>:</td>
                <td style={{ fontWeight: "bold" }}>{validValue("Pesona Kahuripan 1 Blok U1 No 16, Desa Cikahuripan, Kec. Klapanunggal, Kab. Bogor")}</td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top" }}></td>
                <td>Jabatan</td>
                <td style={{ width: "20px" }}>:</td>
                <td style={{ fontWeight: "bold" }}>{validValue("Pimpinan Proyek Pesona Kahuripan 13")}</td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top" }}></td>
                <td>No. KTP</td>
                <td style={{ width: "20px" }}>:</td>
                <td style={{ fontWeight: "bold" }}>{validValue("3217081404910001")}</td>
              </tr>
            </tbody>
          </table>

          <p>
            Bertindak sebagai <b>Wakil</b> dari <b>Developer Pesona Kahuripan</b> dan disebut <b>PIHAK PERTAMA</b>.
          </p>

          <table style={{ marginBottom: "10px", marginTop: "10px" }}>
            <tbody>
              <tr>
                <td style={{ verticalAlign: "top", width: "30px" }}>1.</td>
                <td style={{ width: "120px" }}>Nama </td>
                <td style={{ width: "20px" }}>:</td>
                <td style={{ fontWeight: "bold" }}>{validValue(item?.contract_user?.name)} &nbsp;</td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top" }}></td>
                <td>Alamat</td>
                <td style={{ width: "20px" }}>:</td>
                <td style={{ fontWeight: "bold" }}>{validValue(item?.contract_user?.user_employee?.employee_address[0]?.description)} &nbsp;</td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top" }}></td>
                <td>Tempat/Tanggal Lahir</td>
                <td style={{ width: "20px" }}>:</td>
                <td style={{ fontWeight: "bold" }}>
                  {validValue(item?.contract_user?.user_employee?.birth_place)} &nbsp; / &nbsp;{validValue(handleValidDate(item?.contract_user?.user_employee?.birthat))} &nbsp;
                </td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top" }}></td>
                <td>No. KTP</td>
                <td style={{ width: "20px" }}>:</td>
                <td style={{ fontWeight: "bold" }}>{validValue(item?.contract_user?.user_employee?.employee_identity[0]?.identity_number)} &nbsp;</td>
              </tr>
            </tbody>
          </table>

          <p>
            Dalam hal ini bertindak untuk dan atas nama pribadi, untuk selanjutnya disebut sebagai <b>PIHAK KEDUA</b>.
          </p>

          <div style={{ textAlign: "center", fontWeight: "bold", marginTop: "30px" }}>Pasal 1</div>
          <div style={{ textAlign: "center", fontWeight: "bold", marginBottom: "10px" }}>RUANG LINGKUP PEKERJAAN</div>

          <ol style={{ paddingLeft: "20px" }}>
            <li>
              Perjanjian kerja ini berlaku untuk jangka waktu sampai dengan selesainya proyek <b>Pesona Kahuripan 13</b>, Kecamatan Klapanunggal, Kabupaten Bogor, yang merupakan pekerjaan bersifat sementara dan tidak permanen.
            </li>
            <li>
              Perjanjian ini dimulai sejak tanggal <b>{validValue(handleValidDate(item?.startat))}</b> dan akan berakhir secara otomatis setelah proyek dinyatakan selesai oleh <b>PIHAK PERTAMA</b>, sesuai dengan ketentuan peraturan perundang-undangan yang berlaku.
            </li>
            <li>
              Apabila proyek selesai lebih cepat atau lebih lama dari perkiraan, maka perjanjian ini tetap berakhir pada saat proyek tersebut dinyatakan selesai, tanpa mengurangi hak-hak <b>PIHAK KEDUA</b> sesuai ketentuan hukum yang berlaku.
            </li>
          </ol>

          <div style={{ textAlign: "center", fontWeight: "bold", marginTop: "30px" }}>PASAL 2</div>
          <div style={{ textAlign: "center", fontWeight: "bold", marginBottom: "10px" }}>TATA TERTIB PERUSAHAAN</div>

          <ol style={{ paddingLeft: "20px" }}>
            <li>
              <b>PIHAK KEDUA</b> wajib mematuhi seluruh peraturan dan tata tertib yang ditetapkan oleh <b>PIHAK PERTAMA</b>, baik yang tertulis dalam bentuk peraturan perusahaan, kebijakan internal, maupun yang disampaikan secara lisan oleh atasan langsung.
            </li>
            <li>
              Pelanggaran terhadap tata tertib perusahaan dapat dikenakan sanksi sesuai dengan tingkat pelanggaran, mulai dari <i>teguran lisan</i>, <i>teguran tertulis</i>, <i>skorsing</i>, hingga <i>pemutusan hubungan kerja (PHK)</i>
              sesuai peraturan perundang-undangan yang berlaku.
            </li>
          </ol>

          <div className="pagebreak" style={{ pageBreakAfter: "always" }}>
            <style>{`@media print { .pagebreak { page-break-after: always; } }`}</style>
          </div>
        </div>
        <div style={{ padding: "40px 80px", fontSize: "14px", fontFamily: "serif", color: "#000" }}>
          <div>
            <div style={{ textAlign: "center", fontWeight: "bold", marginBottom: "10px" }}>PASAL 3</div>
            <div style={{ textAlign: "center", fontWeight: "bold", marginBottom: "10px" }}>JAM KERJA</div>
            <ol style={{ paddingLeft: "20px" }}>
              <li>
                <b>PIHAK KEDUA</b> bersedia mengikuti waktu kerja yang ditetapkan oleh <b>PIHAK PERTAMA</b> sesuai dengan kebutuhan operasional perusahaan.
              </li>
              <li>
                Waktu kerja akan dilaksanakan pada hari dan jam yang telah ditentukan oleh <b>PIHAK PERTAMA</b>, dan dapat berubah sewaktu-waktu sesuai kebutuhan pekerjaan di <b>{validValue(item.contract_position && item.contract_position.name)}</b>, tanpa mengurangi hak <b>PIHAK KEDUA</b> sebagai pekerja.
              </li>
              <li>
                <b>PIHAK KEDUA</b> menyatakan kesediaannya untuk menjalankan tugas sesuai penugasan dan target pekerjaan yang diberikan, termasuk apabila diperlukan penyesuaian jadwal kerja pada hari tertentu, lokasi proyek, atau saat menghadapi situasi mendesak yang berkaitan dengan operasional perusahaan.
              </li>
            </ol>
          </div>
          <div style={{ textAlign: "center", fontWeight: "bold", marginTop: "30px" }}>PASAL 4</div>
          <div style={{ textAlign: "center", fontWeight: "bold", marginBottom: "10px" }}>PENEMPATAN, TUGAS, DAN TANGGUNG JAWAB</div>
          <ol style={{ paddingLeft: "20px" }}>
            <li>
              <b>PIHAK KEDUA</b> akan ditempatkan oleh <b>PIHAK PERTAMA</b> untuk bekerja pada DIVISI <b>{validValue(item.contract_position && item.contract_position.position_department && item.contract_position.position_department.name)}</b> di lokasi kerja yang ditentukan oleh perusahaan, yaitu di <b>PESONA KAHURIPAN 13</b> Kecamatan Klapanunggal, Kabupaten Bogor.
            </li>
            <li>
              <b>PIHAK KEDUA</b> bersedia melaksanakan tugas sesuai jabatan yang diberikan, mematuhi arahan atasan langsung, dan bekerja profesional mengikuti SOP perusahaan dalam mendukung operasional dan pengembangan proyek properti.
            </li>
          </ol>

          <div style={{ textAlign: "center", fontWeight: "bold", marginTop: "30px" }}>PASAL 5</div>
          <div style={{ textAlign: "center", fontWeight: "bold", marginBottom: "10px" }}>GAJI POKOK</div>
          <ol style={{ paddingLeft: "20px" }}>
            <li>
              <b>PIHAK KEDUA</b> berhak menerima gaji pokok sebesar <b>Rp. {validValue(currencyFormat(item?.rates))}</b> (<i>{numberToWords(item?.rates, "Rupiah")} </i>) setiap bulan. Gaji pokok tersebut dibayarkan secara tunai oleh <b>PIHAK PERTAMA</b> setiap akhir bulan.
            </li>
          </ol>

          <p style={{ marginTop: "20px" }}>
            Demikianlah perjanjian ini dibuat, disetujui, dan <u>ditanda tangani</u> dalam rangkap dua, asli dan tembusan <u>bermaterai</u> cukup dan berkekuatan hukum yang sama. Satu dipegang oleh <b>PIHAK PERTAMA</b>
            dan lainnya untuk <b>PIHAK KEDUA</b>.
          </p>

          <div style={{ display: "flex", justifyContent: "space-between", marginTop: "40px" }}>
            <div>
              <p>
                <b>PIHAK 1</b>
              </p>
            </div>
            <div>
              <p>Bogor, ………………… {moment().format("YYYY")}</p>
              <p>
                <b>PIHAK 2</b>
              </p>
            </div>
          </div>

          <div style={{ display: "flex", justifyContent: "space-between", marginTop: "80px" }}>
            <div style={{ textAlign: "center" }}>
              <b>{validValue("DIMAS WARDIANSAH RAMADAN")}</b>
            </div>
            <div style={{ textAlign: "center" }}>&nbsp;{validValue(item?.contract_user?.name)} &nbsp;</div>
          </div>
        </div>
      </div>
      {/* /// */}
    </div>
  );
};
